<template>
  <main class="inline">
    <Button
      icon="pi pi-pencil"
      @click="visible = true"
      class="mt-2 p-button-secondary"
    />
    <Dialog
      :visible.sync="visible"
      modal
      header="Modifier help"
      :style="{ width: '50vw' }"
    >
      <Card>
        <!-- <template #title> Nouveau help </template> -->
        <template #content>
          <div class="mb-4">
            <span class="p-float-label">
              <InputNumber id="number" v-model="help.number" />
              <label for="number">N° emplacement</label>
            </span>
          </div>
          <div class="p-inputgroup flex-1">
            <span class="p-float-label">
              <InputText id="name" type="text" v-model="help.name" />
              <label for="name">Nom</label>
            </span>
          </div>
        </template>
      </Card>
      <template #footer>
        <Button label="Annuler" icon="pi pi-times" @click="cancel" text />
        <Button
          label="Valider"
          icon="pi pi-check"
          @click="updateHelp"
          autofocus
        />
      </template>
    </Dialog>
  </main>
</template>
<script>
// import TheWelcome from '../components/TheWelcome.vue'

export default {
  data() {
    return {
      visible: false,
      emit: ["edit"],
      help: { name: "", number: null },
    };
  },
  props: {
    helpToEdit: Object,
  },
  components: {},
  mounted() {
    this.help = this.helpToEdit;
  },
  methods: {
    async updateHelp() {
      try {
        const res = await fetch(
          process.env.VUE_APP_API_BASE_URL + "/api/v1/helps/updateHelp",
          {
            method: "POST",
            body: JSON.stringify(this.help),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.localStorage.token}`,
            },
          }
        );
        console.log(res);
        this.visible = false;
        // this.$emit("visible", false);
        this.$emit("edit", this.help);
        return res;
      } catch (error) {
        console.log(error);
      }
    },

    cancel() {
      this.visible = false;
      // this.$emit("visible", false);
    },
  },
  watch: {
    helpToEdit(value) {
      console.log(value);
      this.help = value;
    },
  },
};
</script>

<style>
.inline {
  display: inline;
}
</style>
